import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { ButtonModule } from 'primeng/button';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
    selector: 'app-duplicate-quote-warning-dialog',
    templateUrl: './duplicate-quote-warning-dialog.component.html',
    styleUrls: ['./duplicate-quote-warning-dialog.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslateModule, ButtonModule],
})
export class DuplicateQuoteWarningDialogComponent {
    // =========================================================================
    // DEPENDENCY INJECTION
    // =========================================================================
    public readonly ref = inject(DynamicDialogRef);

    // =========================================================================
    // PUBLIC METHODS
    // =========================================================================
    public onConfirmDuplicate(): void {
        this.ref.close(true);
    }

    public onCreateVersion(): void {
        this.ref.close(false);
    }

    public onCancel(): void {
        this.ref.close();
    }
}
